import React from "react";
// Components
import { Link } from "react-router-dom";
import { AvatarImage, Svg } from "../atoms/Images";
import { Image } from "semantic-ui-react";
//Constants
import { Roles } from "../../Shared/Constants/Roles";
import i18nstring, { strings } from "../../i18n";
import {
  Courier,
  Dash as DashSvg,
  DataExport,
  Gardener,
  NonProfit,
  TimeWindows,
  Settings,
  EmailNotifications
} from "../../constants/SvgPaths";
import ClipBoard from "../../images/icons/clipBoard.png";
import Dash from "../../images/icons/dash@3x.png";
import Chat from "../../images/icons/chatOutline.png";
import ChatActive from "../../images/icons/chatOutlineActive.png";
import BadgeInActive from "../../images/icons/badge-inactive.png";
import BadgeActive from "../../images/icons/badge-active.png";
//Themes
import "./OrganismStyles.scss";
// import Home from "../../images/svgs/Home.svg";

export function UserHeader({ user, logOut }) {
  const { userName, roles, photoURL } = user;
  const isAdmin = roles[0] === Roles.ADMIN;
  const role = isAdmin
    ? i18nstring(strings.FFC_ADMIN)
    : i18nstring(strings.NON_PROFIT);
  return (
    <div className="user_header">
      <AvatarImage avatar={photoURL} />
      <div className="avatar_component avatar_name">{userName}</div>
      <div className="avatar_component avatar_role">{role}</div>
      <div className="avatar_component avatar_logout" onClick={logOut}>
        {i18nstring(strings.LOG_OUT)}
      </div>
    </div>
  );
}

export function NavRoute({ name, to, isActive, chatsBadge = null, onClick, onActiveClick }) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    if (isActive && onActiveClick) {
      onActiveClick();
    }
  };

  return isActive ? (
    <Link to={to} onClick={handleClick}>
      <div className="side_nav_route_active">
        <NavIcon isActive={isActive} name={name} />
        <div className="side_nav_route_name_active">{name}</div>
      </div>
    </Link>
  ) : (
    <Link to={to} onClick={handleClick}>
      <div className="side_nav_route">
        <NavIcon isActive={isActive} name={name} />
        <div
          className="side_nav_route_name"
          style={{ display: "flex", alignItems: "center" }}
        >
          {name}
          {chatsBadge && chatsBadge != "0" ? (
            <div
              style={{
                color: "#fff",
                width: 18,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: 18,
                padding: 2,
                borderRadius: 9,
                fontSize: 12,
                marginLeft: 5,
                backgroundColor: "#5db99d"
              }}
            >
              {Number(chatsBadge) > 9 ? "9+" : chatsBadge}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </Link>
  );
}

export function LinkNavRoute({ name, to, newTab }) {
  return (
    <a href={to} rel="noreferrer" target={newTab ? "_blank" : "_self"}>
      <div className="side_nav_route">
        <NavIcon name={name} />
        <div className="side_nav_route_name">{name}</div>
      </div>
    </a>
  );
}

export function NavIcon({ isActive, name }) {
  switch (name) {
    case i18nstring(strings.SIDE_DASHBOARD):
      return <Svg active={isActive} paths={DashSvg} />;
    case i18nstring(strings.COURIER_REVIEW):
      return <Svg active={isActive} paths={Courier} />;
    case i18nstring(strings.DATA_EXPORT):
      return <Svg active={isActive} paths={DataExport} />;
    case i18nstring(strings.GARDENER_REVIEW):
      return <Svg active={isActive} paths={Gardener} />;
    case i18nstring(strings.NON_PROFIT_REVIEW):
      return <Svg active={isActive} paths={NonProfit} />;
    case i18nstring(strings.SELF_SERVICE):
      return <Svg active={isActive} paths={NonProfit} />;
    case i18nstring(strings.FOOD_WEIGHT_REVIEW):
      return <Svg active={isActive} paths={NonProfit} />;
    case i18nstring(strings.SIDE_BADGE):
      return (
        <Image
          src={isActive ? BadgeActive : BadgeInActive}
          className="sidebar-custom-icon"
        />
      );
    case i18nstring(strings.CHATS):
      return (
        <Image
          src={isActive ? ChatActive : Chat}
          className="sidebar-custom-icon"
        />
      );
    case i18nstring(strings.LOCATIONS_AND_TIMES):
      return <Svg active={isActive} paths={TimeWindows} />;
    case i18nstring(strings.SETTINGS):
      return <Svg active={isActive} paths={Settings} />;
    case i18nstring(strings.SIDE_HELP):
      return <Svg paths={NonProfit} />;
    case i18nstring(strings.SIDE_REPORT_BUG):
      return (
        <Image
          src={Dash}
          style={{
            marginLeft: "4px",
            marginRight: "3px",
            width: "23px",
            height: "23px"
          }}
        />
      );
    case i18nstring(strings.SIDE_REQUEST_FEATURE):
      return <Svg paths={DataExport} />;
    case i18nstring(strings.SIDE_EMAIL_NOTIFICATION):
      return <Svg active={isActive} paths={EmailNotifications} />;
    case i18nstring(strings.SIDE_INTEGRATIONS):
      return <IntegrationsIcon active={isActive} />;
    case i18nstring(strings.SURVEY):
      return (
        <Image
          src={ClipBoard}
          style={{
            marginLeft: "5px",
            width: "23px",
            height: "23px"
          }}
        />
      );
    default:
      return null;
  }
}

// Puzzle/extension glyph for the Integrations nav item. Uses its own 24x24
// viewBox (so the path isn't mis-scaled) but the shared `icon` class and the
// same active/inactive fills as the other sidebar icons.
export function IntegrationsIcon({ active }) {
  const fill = active ? "#fff" : "#96a1a8";
  return (
    <svg className="icon" viewBox="0 0 24 24">
      <path
        fill={fill}
        d="M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"
      />
    </svg>
  );
}
